export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sellCarIconEnabled.ef35a2b1.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};